export const messages = {
    gb: {
        header: "Quine-McCluskey minimization",
        fun_chooser: {
            select_type: "Select function specification type",
            text_vars_count: "Select number of variables",
            select_args: "Select arguments",
        },
        fun_minimizer: {
            button_process: "Process",
            text_mdnf: "Minimal SOP",
            text_mcnf: "Minimal POS",
            transistors_count: "Transistors number",
            button_veitch: "Veitch diagram",
            button_debug: "Debug",
        },
        veitch: {
            variables: 'Variable names',
            unsupported: 'Only functions with 3-5 variables are supported',
            show_fill: 'Show fill',
            show_stroke: 'Show stroke',
        }
    },
    ru: {
        header: "Минимизация по Квайну-МакКласки",
        fun_chooser: {
            select_type: "Выберите тип задания функции",
            text_vars_count: "Выберите количество переменных",
            select_args: "Выберите аргументы",
        },
        fun_minimizer: {
            button_process: "Вычислить",
            text_mdnf: "МДНФ",
            text_mcnf: "МКНФ",
            transistors_count: "Количество транзисторов",
            button_veitch: "Диаграмма Вейча",
            button_debug: "Отладка",
        },
        veitch: {
            variables: 'Имена переменных',
            unsupported: 'Поддерживаются только функции 3-5 переменных',
            show_fill: 'Показать заливку',
            show_stroke: 'Показать обводку',
        }
    }
}
